import {Directive,ElementRef,Renderer,OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { MenuService } from './vnpt-menu.service'
declare var jQuery: any;
declare var $: any;

@Directive({
    selector: 'vnpt-quicklink',
    providers:[MenuService]
 })

export class VnptQuickLink implements OnInit {
  text:string;
  constructor(private service: MenuService,
    private authService:AuthService,
    private ElementRef:ElementRef, 
    private Renderer:Renderer,
    private router:Router
 ) {}

  ngOnInit() { 
      this.text = '<div id="sidebar"><ul>';
      // this.text += '<li><a data-toggle="tooltip" title="Trang chủ" data-placement="right" routerLink="/home" routerLinkActive="active" href="#/"><i class="fa fa-home green"></i></a></li>';
      this.service.GetQuickLink().subscribe(
          (data) => {
                // if (data != null || data != undefined) {
                //   this.genChild(data);
                // }
              // this.text+='<li><a data-toggle="tooltip" title="Xử lý phản ánh" data-placement="right" routerLink="/xl-xu-ly-su-co/xu-ly-su-co-new" routerLinkActive="active" href="#/xl-xu-ly-su-co/xu-ly-su-co-new"><i class="fa fa fa-wrench"></i></a></li>';
              this.text+='<li><a data-toggle="tooltip" title="Xử lý phản ánh" data-placement="right" routerLink="/phan-anh/browse" routerLinkActive="active" href="#/phan-anh/browse"><i class="fa fa fa-wrench"></i></a></li>';
              this.text+='<li><a data-toggle="tooltip" title="Xem chi tiết quy trình xử lý" data-placement="right" routerLink="/san-pham/chi-tiet-quy-trinh" routerLinkActive="active" href="#/san-pham/chi-tiet-quy-trinh"><i class="fa fa-retweet"></i></a></li>';
              // this.text+='<li><a data-toggle="tooltip" title="Cẩm nang xử lý" data-placement="right" routerLink="/danh-muc/cam-nang" routerLinkActive="active" href="#/danh-muc/cam-nang"><i class="fa fa-file-text-o"></i></a></li>';
              this.text+='<li><a data-toggle="tooltip" title="Tài liệu hướng dẫn sử dụng" data-placement="right" routerLink="/sys-hdsd" routerLinkActive="active" href="#/sys-hdsd"><i class="fa fa fa-book"></i></a></li>';
              this.text += "</ul></div>";                      
              this.ElementRef.nativeElement.innerHTML = this.text;
               $(function () {
                  $('[data-toggle="tooltip"]').tooltip();
              });
          },
          er => {
              if (er.status == 401) {
                  console.log(er);
              }
          });
     

  }
  genChild(childMenuList: any) {
    for (let i = 0; i < childMenuList.length; i++) {
      this.text += '<li><a data-toggle="tooltip" title="' + childMenuList[i].Ten + '" data-placement="right" routerLink="/' + childMenuList[i].RouterPath + '" routerLinkActive="active" href="#/' + childMenuList[i].RouterPath + '"><i class="' + childMenuList[i].Styles + '"></i></a></li>';
    }
  }  
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/directives/vnpt-quicklink.directive.ts